import { useContext, useEffect } from "react";
import { AppStateContext } from "../../state/AppProvider";
import { ImageInput } from "../../api/models";

import { ChatResponse } from "../../api";

interface Props {
    message: string;
    files?: string[];
    images?: ImageInput[];

}

export const UserChatMessage = ({ message, files = [], images = [] }: Props) => {
    const appStateContext = useContext(AppStateContext);

    return (
        <div className="w-full">
            <div
                className={"transition-[padding] duration-200 py-[18px] px-4 text-base m-auto " + (appStateContext?.state.isChatHistoryOpen ? "" : "lg:px-16")}
            >
                <div className="mx-auto flex flex-1 text-base gap-4 lg:gap-6 lg:max-w-3xl">


                    <div className="flex w-full flex-col gap-1 items-end">
                        {files.map((file, i) => (
                            <div key={`${file}-${i}`} className="relative max-w-[70%] rounded-lg bg-eq-green pl-10 pr-5 py-2.5 text-eq-white shadow-chat">
                                <span className="material-symbols-outlined text-[1.25rem] absolute bottom-[.75rem] left-4">attach_file</span>
                                <span>{file}</span>
                            </div>
                        ))}

                        {images.map((img, i) => ( // render attached images
                            <div key={`${img.name || "image"}-${i}`} className="relative max-w-[70%]">
                                <img
                                    src={img.dataUrl}
                                    alt={img.name || `image-${i}`}
                                    className="rounded-lg shadow-chat max-h-64 object-contain"
                                />
                            </div>
                        ))}
                        <div className="relative max-w-[70%] rounded-lg bg-eq-green px-5 py-2.5 text-eq-white shadow-chat whitespace-pre-wrap">
                            {message}</div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
};
